import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ModalStore } from '../types/store';

export const useModalStore = create<ModalStore>()(
    devtools((set) => ({
        isConsultationModalOpen: false,
        setIsConstultationModalOpen: (isConsultationModalOpen) => set({ isConsultationModalOpen }),

        isSuccessFormSentModalOpen: false,
        setIsSuccessFormSentModalOpen: (isSuccessFormSentModalOpen) => set({ isSuccessFormSentModalOpen }),

        isStoriesModalOpen: false,
        setIsStoriesModalOpen: (isStoriesModalOpen) => set({ isStoriesModalOpen }),

        isGoalModalOpen: false,
        setIsGoalModalOpen: (isGoalModalOpen) => set({ isGoalModalOpen }),

        errorModalProps: { opened: false, title: '' },
        setErrorModalProps: (errorModalProps) => set({ errorModalProps }),

        isDepositModalOpen: false,
        setIsDepositModalOpen: (isDepositModalOpen) => set({ isDepositModalOpen }),

        isGoalUpdatedModalOpen: false,
        setIsGoalUpdatedModalOpen: (isGoalUpdatedModalOpen) => set({ isGoalUpdatedModalOpen }),

        isGoalChosenModalOpen: false,
        setIsGoalChosenModalOpen: (isGoalChosenModalOpen) => set({ isGoalChosenModalOpen }),
    }))
);
